export const Form = {
  idenAmparoLegal: 0,
  atoAdm: null,
  orgao: {
    idenOrgao: "",
  },
  tipoAto: {
    idenTipoAto: "",
  },
  esfera: null,
  numrAto: "",
  numrAnoAto: null,
  dataPublicacaoAto: "",
  descComplementoAmparo: "",
  dataInicioVigencia: "",
  dataTerminoVigencia: "",
  statusAmparoLegal: "",
  descAmparoLegal: "",
};

const url = "/amparoslegais";
const id = "idenAmparoLegal";
const esferaOrgao = "/orgaos/esferasorgao";

export function pesquisarAll() {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/ativos/paginado`).then((res) => {
      resolve(res.data);
    });
  });
}

export function pesquisarLista() {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/lista`).then((res) => {
      resolve(res.data);
    });
  });
}

export function pesquisarListaAtivos() {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/lista`).then((res) => {
      resolve(res.data);
    });
  });
}

export function buscarSemObrigacao(data) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/ativos/semobrigacao`, JSON.stringify(data)).then((res) => {
      resolve(res.data);
    });
  });
}

export function buscarSemTipoCertidao(data) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/ativos/semtipocertidao`, JSON.stringify(data)).then((res) => {
      resolve(res.data);
    });
  });
}

export function pesquisarAmparo(filtro) {
  return new Promise((resolve, reject) => {
    window.$http.post(`/amparoslegais/buscarporfiltros`, JSON.stringify(filtro)).then((res) => {
      resolve(res.data);
    });
  });
}

export function buscarPersonalizada(data) {
  return new Promise((resolve, reject) => {
    window.$http.post(`${url}/buscarporfiltros`, JSON.stringify(data)).then((res) => {
      resolve(res.data);
    });
  });
}

export function buscarEsferaOrgaoPeloCodigo(codigo) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${esferaOrgao}?idenEsferaGoverno=${codigo}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function buscarPeloCodigo(codigo) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/${codigo}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function salvar(parm) {
  return new Promise(async (resolve, reject) => {
    if (parm[id] && parm[id] !== 0) {
      await atualizar(parm).then((res) => {
        resolve({ ...res, type: "UPD" });
      });
    } else {
      await criar(JSON.stringify(parm)).then((res) => {
        resolve({ ...res, type: "INS" });
      });
    }
  });
}

export function remover(data) {
  return new Promise((resolve, reject) => {
    window.$http.delete(`${url}/${data[id]}`).then((res) => {
      resolve();
    });
  });
}

export function atualizar(id, parm) {
  return new Promise((resolve, reject) => {
    window.$http.put(`${url}/${id}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    });
  });
}

export function criar(parm) {
  return new Promise((resolve, reject) => {
    window.$http.post(`${url}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    });
  });
}
